import type { ReactNode } from "react";
import { cn } from "@shared-kernel/primary/shared/shadcn/utils/utils";

interface PageWrapperProps {
  children: ReactNode;
  className?: string;
}

export const PageWrapper = ({ children, className }: PageWrapperProps) => <div className={cn("space-y-4", className)}>{children}</div>;
